
const runes = {
  "El": {
    level: 11,
    dropChance: '50.06%',
    boss: 'Countess',
    difficulty: 'Normal',
    sockProps: {
      'Weapon': '+50 AR, +1 Light Radius',
      'Armor/Helm/Shield': '+1 Light Radius, +15 Defense'
    }
  },
  "Eld": {
    level: 11,
    dropChance: '35.71%',
    boss: 'Countess',
    difficulty: 'Normal',
    sockProps: {
      'Weapon': '+75% Damage vs. Undead, +50 Attack Rating vs. Undead *',
      'Armor/Helm/Shield': 'Lowers Stamina drain by 15%',
      'Shield': '+7% Blocking'
    }

  },
  "Tir": {
    level: 13,
    dropChance: '25.20%',
    boss: 'Countess',
    difficulty: 'Nightmare',
    sockProps: {
      'Weapon': '+2 Mana Per Kill',
      'Armor/Helm/Shield': '+2 Mana Per Kill'
    }
  },
  "Nef": {
    level: 13, 
    dropChance: '17.33%',
    boss: 'Countess',
    difficulty: 'Nightmare',
    sockProps: {
      'Weapon': 'Knockback',
      'Armor/Helm/Shield': '+30 Defense vs. Missile'
    }
  },
  "Eth": {
    level: 15, 
    dropChance: '18.14%',
    boss: 'Countess',
    difficulty: 'Nightmare',
    sockProps: {
      'Weapon': '-25% Target Defense',
      'Armor/Helm/Shield': 'Regenerate Mana 15%'
    }
  },
  "Ith": {
    level: 15, 
    dropChance: '12.32%',
    boss: 'Countess',
    difficulty: 'Nightmare',
    sockProps: {
      'Weapon': '+9 to Maximum Damage',
      'Armor/Helm/Shield': '15% Damage Taken Goes to Mana'
    }
  },
  "Tal": {
    level: 17, 
    dropChance: '15.28%',
    boss: 'Countess',
    difficulty: 'Nightmare',
    sockProps: {
      'Weapon': '75 Poison damage over 5 seconds',
      'Armor/Helm/Shield': '+35% Poison Resistance'
    }
  },
  "Ral": {
    level: 19, 
    dropChance: '10.37%',
    boss: 'Countess',
    difficulty: 'Nightmare',
    sockProps: {
      'Weapon': '',
      'Armor/Helm/Shield': ''
    }
  },
  "Ral": {
    level: 19, 
    dropChance: '10.37%',
    boss: 'Countess',
    difficulty: 'Nightmare',
    sockProps: {
      'Weapon': '+5-30 Fire Damage',
      'Armor/Helm/Shield': '+35% Fire Resistance'
    }
  },
  "Ort": {
    level: 21, 
    dropChance: '10.87%',
    boss: 'Countess',
    difficulty: 'Nightmare',
    sockProps: {
      'Weapon': '+1-50 Lightning Damage',
      'Armor/Helm/Shield': '+35% Lightning Resistance'
    }
  },
  "Thul": {
    level: 23, 
    dropChance: '7.33%',
    boss: 'Countess',
    difficulty: 'Nightmare',
    sockProps: {
      'Weapon': '+3-14 Cold Damage (Cold Length 3 seconds)',
      'Armor/Helm/Shield': '+35% Cold Resistance'
    }
  },
  "Amn": {
    level: 25, 
    dropChance: '6.74%',
    boss: 'Countess',
    difficulty: 'Nightmare',
    sockProps: {
      'Weapon': '7% Life Stolen Per Hit',
      'Armor/Helm/Shield': 'Attacker takes 14 damage'
    }
  },
  "Sol": {
    level: 27, 
    dropChance: '4.53%',
    boss: 'Countess',
    difficulty: 'Nightmare',
    sockProps: {
      'Weapon': '+9 to Minimum Damage',
      'Armor/Helm/Shield': '-7 Damage Taken'
    }
  },
  "Shael": {
    level: 29, 
    dropChance: '3.59%',
    boss: 'Countess',
    difficulty: 'Nightmare',
    sockProps: {
      'Weapon': 'Faster Attack Rate (+20)',
      'Armor/Helm': 'Faster Hit Recovery (+20)',
      'Shield': 'Faster Block Rate (+20)'
    }  
  },
  "Dol": {
    level: 31, 
    dropChance: '2.41%',
    boss: 'Countess',
    difficulty: 'Nightmare',
    sockProps: {
      'Weapon': '25% Chance that Hit Causes Monster to Flee',
      'Armor/Helm/Shield': '+7 Replenish Life'
    }
  },
  "Hel": {
    level: 0, 
    dropChance: '1.88%',
    boss: 'Countess',
    difficulty: 'Nightmare',
    sockProps: {
      'Weapon': '-20% Requirements',
      'Armor/Helm/Shield': '-15% Requirements'
    }
  },
  "Io": {
    level: 35, 
    dropChance: '1.24%',
    boss: 'Countess',
    difficulty: 'Nightmare',
    sockProps: {
      'Weapon': '+10 Vitality',
      'Armor/Helm/Shield': '+10 Vitality'
    }
  },
  "Lum": {
    level: 37, 
    dropChance: '0.932%',
    boss: 'Countess',
    difficulty: 'Hell',
    sockProps: {
      'Weapon': '+10 Energy',
      'Armor/Helm/Shield': '+10 Energy'
    }
  },
  "Ko": {
    level: 39, 
    dropChance: '0.622%',
    boss: 'Countess',
    difficulty: 'Hell',
    sockProps: {
      'Weapon': '+10 Dexterity',
      'Armor/Helm/Shield': '+10 Dexterity'
    }
  },
  "Fal": {
    level: 41, 
    dropChance: '0.470%',
    boss: 'Countess',
    difficulty: 'Hell',
    sockProps: {
      'Weapon': '+10 Strength',
      'Armor/Helm/Shield': '+10 Strength'
    }
  },
  "Lem": {
    level: 43, 
    dropChance: '0.314%',
    boss: 'Countess',
    difficulty: 'Hell',
    sockProps: {
      'Weapon': '+75% Extra Gold from Monsters',
      'Armor/Helm/Shield': '+50% Extra Gold from Monsters'
    }
  },
  "Pul": {
    level: 45, 
    dropChance: '0.236%',
    boss: 'Countess',
    difficulty: 'Hell',
    sockProps: {
      'Weapon': '+75% Damage to Demons, +100 AR against Demons',
      'Armor/Helm/Shield': '+30% Defense'
    }
  },
  "Um": {
    level: 47, 
    dropChance: '0.157%',
    boss: 'Countess',
    difficulty: 'Hell',
    sockProps: {
      'Weapon': '25% Chance of Open Wounds',
      'Armor/Helm': '+15% Resist All',
      'Shield': '+22% Resist All'
    }
  },
  "Mal": {
    level: 49, 
    dropChance: '0.135%',
    boss: 'Countess',
    difficulty: 'Hell',
    sockProps: {
      'Weapon': 'Prevent Monster Healing',
      'Armor/Helm/Shield': 'Reduce Magic Damage by 7'
    }
  },
  "Ist": {
    level: 51, 
    dropChance: '0.090%',
    boss: 'Countess',
    difficulty: 'Hell',
    sockProps: {
      'Weapon': '+30% Better Chance of Finding Magical Items',
      'Armor/Helm/Shield': '+25% Better Chance of Finding Magical Items'
    }
  },
  "Gul": {
    level: 53, 
    dropChance: '0.0011%',
    boss: 'Andariel',
    difficulty: 'Hell',
    sockProps: {
      'Weapon': '+20% AR',
      'Armor/Helm/Shield': '+5 to Max Resist Poison'
    }
  },
  "Vex": {
    level: 55, 
    dropChance: '0.0008%',
    boss: 'Andariel',
    difficulty: 'Hell',
    sockProps: {
      'Weapon': '7% Mana Leech',
      'Armor/Helm/Shield': '+5 to Max Fire Resist'
    }
  },
  "Ohm": {
    level: 57, 
    dropChance: '0.0011%',
    boss: 'Andariel',
    difficulty: 'Hell',
    sockProps: {
      'Weapon': '+50% Damage',
      'Armor/Helm/Shield': '+5 to Max. Resist Cold'
    }
  },
  "Lo": {
    level: 57, 
    dropChance: '0.0004%',
    boss: 'Andariel',
    difficulty: 'Hell',
    sockProps: {
      'Weapon': '20% Chance of Deadly Strike',
      'Armor/Helm/Shield': '+5 to Max. Resist Lightning'
    }
  },
  "Sur": {
    level: 61, 
    dropChance: '0.0004%',
    boss: 'Duriel',
    difficulty: 'Hell',
    sockProps: {
      'Weapon': '20% Chance of Hit Blinds Target',
      'Armor/Helm/Shield': '+5% total Mana'
    }
  },
  "Ber": {
    level: 63, 
    dropChance: '0.0002%',
    boss: 'Duriel',
    difficulty: 'Hell',
    sockProps: {
      'Weapon': '20% Chance of Crushing Blow',
      'Armor/Helm/Shield': 'Damage Reduced by 8%'
    }
  },
  "Jah": {
    level: 65, 
    dropChance: '0.0002%',
    boss: 'Mephisto',
    difficulty: 'Hell',
    sockProps: {
      'Weapon': 'Ignores Target Defense',
      'Armor/Helm': '+5% of total Hit Points',
      'Shield': '+50 Hit Points'
    }
  },
  "Cham": {
    level: 67, 
    dropChance: '0.0001%',
    boss: 'Mephisto',
    difficulty: 'Hell',
    sockProps: {
      'Weapon': '32% Chance of Hit Freezing Target for 3 seconds',
      'Armor/Helm/Shield': 'Cannot be Frozen'
    }
  },
  "Zod": {
    level: 69, 
    dropChance: '0.00003%',
    boss: 'Baal',
    difficulty: 'Hell',
    sockProps: {
      'Weapon': 'Indestructible',
      'Armor/Helm/Shield': 'Indestructible'
    }
  },
}

export default runes;